import { Avatar, Tooltip } from "antd";
import { FaBed, FaExclamationTriangle, FaCircle } from "react-icons/fa";
import { FaDumbbell, FaPersonWalkingLuggage, FaTrophy } from "react-icons/fa6";
import { IoMdAirplane } from "react-icons/io";
import { IoMan } from "react-icons/io5";
import { GiLeg } from "react-icons/gi";
import { BsCameraReelsFill } from "react-icons/bs";
import { MdOutlineTimer, MdRestaurant } from "react-icons/md";
import React from "react";

const getIcon = (key: string, size: number): React.ReactNode => {
  const props = { size };
  const map: Record<string, React.ReactNode> = {
    bed: <FaBed {...props} />,
    plane: <IoMdAirplane {...props} />,
    luggage: <FaPersonWalkingLuggage {...props} />,
    bicep: <FaDumbbell {...props} />,
    leg: <GiLeg {...props} />,
    fork: <MdRestaurant {...props} />,
    film: <BsCameraReelsFill {...props} />,
    timer: <MdOutlineTimer {...props} />,
    trophy: <FaTrophy {...props} />,
    person: <IoMan {...props} />,
    warning: <FaExclamationTriangle {...props} />,
    circle: <FaCircle {...props} />,
  };
  return map[key] ?? <FaCircle {...props} />;
};

interface CalendarTag {
  id: string;
  label: string;
  color: string;
  icon: string;
  is_internal: boolean;
  created_by_id: number | null;
}

interface TagAvatarProps {
  tag: CalendarTag;
  size?: number | "small" | "large" | "default";
  style?: React.CSSProperties;
  showTooltip?: boolean;
}

export const TagAvatar = ({ tag, size = 18, style, showTooltip = true }: TagAvatarProps) => {
  const numericSize = typeof size === "number" ? size : 18;
  const icon = getIcon(tag.icon, numericSize * 0.55);

  const avatar = (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...style,
      }}
    >
      <Avatar icon={icon} size={size} style={{ backgroundColor: tag.color }} />
    </span>
  );

  if (!showTooltip) return avatar;

  return <Tooltip title={tag.label}>{avatar}</Tooltip>;
};
